import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

type PageHeaderProps = {
  title: string;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
  secondaryActions?: React.ReactNode;
};

export default function PageHeader({ title, subtitle, action, secondaryActions }: PageHeaderProps) {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', sm: 'flex-start' }} spacing={{ xs: 1.5, sm: 2 }} sx={{ pt: { xs: 1, sm: 1.5 }, mb: { xs: 2.5, sm: 3 } }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h4" sx={{ fontSize: { xs: '2rem', sm: '2.25rem' }, lineHeight: 1.15, mb: subtitle ? 0.75 : 0 }}>{title}</Typography>
        {subtitle && <Typography variant="body1" color="text.secondary" sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}>{subtitle}</Typography>}
      </Box>
      {(action || secondaryActions) && <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'stretch', sm: 'center' }} sx={{ flexShrink: 0, width: { xs: '100%', sm: 'auto' }, flexWrap: 'wrap', '& .MuiButton-root': { maxWidth: '100%' } }}>{secondaryActions}{action}</Stack>}
    </Stack>
  );
}
